<template>
	<ul><slot /></ul>
</template>

<script>
	
	import $ from "jquery"
	import "jquery.cycle2"
	import "jquery.cycle2.carousel"
	
	export default {
		name: "cycle",
		props: {
			config: {
				type: Object,
				default () {
					return {}
				}
			}
		},
		mounted () {
			const config = Object.assign({ log: false, slides: "> li" }, this.config)
			$(this.$el).cycle(config)
		},
		beforeDestroy () {
			$(this.$el).cycle('destroy')
		}
	}
	
</script>


// WEBPACK FOOTER //
// src/components/Cycle.vue